<template>
  <div class="container">
    <Header
      name="Paramètres du profil"
      :buttons="[
        {
          class: 'outline secondary icon icon-left',
          label: 'Retourner à l\'accueil',
          icon: 'bi-arrow-left',
          click: () => {
            $router.push({ name: 'home' });
          },
        },
      ]"
    />
    <TabsNavigation
      :tabs="['Informations du compte', 'Onboarding']"
      @changeTab="(value) => (state.currentTab = value)"
    />
    <transition mode="out-in" name="fade">
      <div class="primary-container" :key="tabsContent[state.currentTab]">
        <div class="content-container">
          <component :is="tabsContent[state.currentTab]" />
          <div class="links-container">
            <a href="https://yuzu.hr/legal/cgu.pdf" target="_blank"
              >Conditions de service</a
            >
            <a href="https://yuzu.hr/legal/privacy.pdf" target="_blank"
              >Politique de confidentialité</a
            >
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import Header from "@/components/Header.vue";
import Informations from "./partials/Informations.vue";
import Notifications from "./partials/Notifications.vue";
import Onboarding from "./partials/Onboarding.vue";

const tabsContent = [Informations, Onboarding, Notifications];

const state = reactive({
  currentTab: 0,
});
</script>
